import React, { useState, useEffect, useContext } from 'react'
import { Redirect } from 'react-router-dom'
import { Form } from 'reactstrap'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { defaultLink } from '../../utils/consts'
import PrimaryButton from '../common/buttons/PrimaryButton'
import doLogin from '../../utils/doLogin'
import generateFormikInputs from '../../utils/generateFormikInputs'
import useQuery from '../../utils/useQuery'
import { formsInputsData, initialValues, FormSchema } from './config'
import MessageErrorWithTraslation from '../common/MessageErrorWithTraslation'
import { logoImage, logoTelmex, infoImage } from '../../config'
import { AuthUserContext } from '../common/Session'
import useStyles from './styles'


const Login = () => {
  const [error, setError] = useState(null)
  const { auth, login: authenticate, fetchAvatar } = useContext(AuthUserContext)
  const isMobile = useMediaQuery('(max-width:900px)')
  const { t } = useTranslation(['translation', 'COMMON'])
  const classes = useStyles()
  const query = useQuery()

  const alertCode = query.get('alertCode')

  useEffect(() => {
    if (alertCode) {
      setError({ resource: 'LOGIN', errorCode: alertCode })
    }
  }, [alertCode])

  const login = async (values) => {
    // Formik onSubmit callback should be async!
    doLogin({ ...values, username: values.username.trim() })
      .then(authenticate)
      .then(fetchAvatar)
      .catch(err => setError(err))
  };

  if (auth) return <Redirect to={defaultLink} />
  return (
    <div className={classes.loginContainer}>
      <div className={classes.logosContainer}>
        <img src={logoImage} alt="logo" />
        <img src={logoTelmex} alt="logo-telmex" />
      </div>
      {!isMobile && (
        <div className={classes.infoImage}>
          <img src={infoImage} alt="" />
        </div>
      )}
      <div className={classes.loginForm}>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => login(values)}
          validationSchema={FormSchema}
        >
          {({
            handleSubmit,
            isSubmitting,
            ...formikProps
          }) => (
            <Form onSubmit={handleSubmit}>
              {generateFormikInputs(formsInputsData, formikProps, false)}
              <MessageErrorWithTraslation error={error} />
              <PrimaryButton
                className={classes.button}
                type="submit"
                color="primary"
                disabled={isSubmitting}
              >
                {t('LOGIN.SUBMIT_BUTTON')}
              </PrimaryButton>
            </Form>
          )}
        </Formik>
        <p className={classes.text}>
          {t('LOGIN.SUBTITLE')}
          {/* <NavLink className={classes.link} to="/register">Registrate</NavLink> */}
        </p>
        <p className={classes.version}>
          {t('LOGIN.VERSION')}
        </p>
      </div>
    </div>
  )
}

export default Login
